import { createBrowserRouter } from "react-router-dom";

import { routes } from "./routes.description";

export default createBrowserRouter([...routes]);
